import React, { Component } from 'react';

class IconLogoFacebook extends Component {
  render() {
    return (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="#000000" xmlns="http://www.w3.org/2000/svg">
				<circle cx="24" cy="24" r="24"/>
				<path fillRule="evenodd" clipRule="evenodd" d="M33.3422 30.9375L34.4062 24H27.75V19.498C27.75 17.6 28.6798 15.75 31.6612 15.75H34.6875V9.84375C34.6875 9.84375 31.941 9.375 29.3152 9.375C23.833 9.375 20.25 12.6975 20.25 18.7125V24H14.1562V30.9375H20.25V47.7084C21.4719 47.9002 22.7242 48 24 48C25.2758 48 26.5281 47.9002 27.75 47.7084V30.9375H33.3422Z" fill="#FFFFFF"/>
			</svg>
    )
  }
}

export default IconLogoFacebook;